import Vue from 'vue';

export const useVueJwtDecode = () => Vue.prototype.$jwtDec;
